module.exports = __webpack_public_path__ + "img/RS.416524a8.svg";